import { createSlice } from '@reduxjs/toolkit'
import apiGateway from '../../../services/apiGateway'
import getEnvironment from '@bt-react/libs/getEnvironment'
import { addEntry } from '../../../lib/audit'

enum EnvStreamIngestUrl {
  INT05 = 'd1k17njqjk6o9e',
  TEST01 = 'd1rhkzzjk2slfg',
  STAGE = 'd2j05bns4grazx',
  PROD = 'd57t2r22j2mid'
}

const getEnvStreamIngestUrl = () => {

  switch (getEnvironment(true).domain) {
    case 'int05.brighttalk.net':
      return EnvStreamIngestUrl.INT05
    case 'test01.brighttalk.net':
      return EnvStreamIngestUrl.TEST01
    case 'stage.brighttalk.net':
      return EnvStreamIngestUrl.STAGE
    case 'brighttalk.com':
      return EnvStreamIngestUrl.PROD
    default:
      break
  }

}

export interface EventStreamSlice {
  streamUrl: string
  streamKey: string
  streamVideoUrl: string
}

export const eventStreamDefaultState: EventStreamSlice = {
  streamUrl: '',
  streamKey: '',
  streamVideoUrl: ''
}

const eventStreamSlice = createSlice({
  name: 'eventStream',
  initialState: eventStreamDefaultState,
  reducers: {
    setEventStreamDetails( state, { payload }) {

      if ( payload.streamDetails?.resource.mode !== 'StreamIngestCostSaving' &&
        payload.streamDetails?.resource.mode !== 'StreamIngest' ||
        payload.streamDetails?.status !== 'Created') return

      const streamUrl = payload.streamDetails.parameters.StreamIngestInputUrl
      const key = streamUrl.lastIndexOf('/')
      const streamEnvUrl = getEnvStreamIngestUrl()
      const parts = streamUrl.split("/");
      const streamId = parts[3];

      state.streamUrl = streamUrl.substr(0, streamUrl.lastIndexOf('/'))
      state.streamKey = streamUrl.substring(key + 1)
      state.streamVideoUrl = `https://${streamEnvUrl}.cloudfront.net/stream/${streamId}/stream.m3u8`

    }
  }

})

export const fetchEventStreamDetails = (roomname: string | null) => async (dispatch) => {

  if (roomname == null) return

  const payloadForReducer = {
    streamDetails: {},
    roomname
  }

  try {

    const response = await apiGateway.getEventStreamDetails(roomname)

    payloadForReducer.streamDetails = response.data

  } catch (e) {

    addEntry('PresenterService', 'EventStreamFetching', `Error getting event stream details: ${e}`)
    return
  }

  dispatch(eventStreamSlice.actions.setEventStreamDetails(payloadForReducer))

}

export default eventStreamSlice